import { createAxiosThunk } from 'utils/reduxUtil'
import api from 'api/axios/foka'
import { initialState } from '../channelAddSlice'

const checkUnifiedUrl = createAxiosThunk(
  'channelAdd/checkUnifiedUrl',
  (noArgs, { getState }) =>
    api.channel.checkConnections(getState().channel.channelAdd.unifiedUrl)
)

checkUnifiedUrl.reducers = builder => {
  builder.addCase(checkUnifiedUrl.pending, state => {
    state.isUnifiedUrlChecked = initialState.isUnifiedUrlChecked
  })

  builder.addCase(checkUnifiedUrl.fulfilled, state => {
    state.isUnifiedUrlChecked = true
  })

  builder.addCase(checkUnifiedUrl.rejected, (state, { payload }) => {
    state.isUnifiedUrlChecked = true
    state.apiError = payload
  })
}

export default checkUnifiedUrl
